const RoundSize = ({ value, lstValue }: { value: number[], lstValue: object[] | any }) => {

    let objectValue = null;
    const objectColor: object | any = lstValue?.find((item: any) => !item.is_color);
    if (objectColor && value?.length > 0) {
        objectValue = objectColor?.values?.find((item: any) => item.id === value[0]);
        if (objectValue) {
            objectValue = objectValue?.value;
        }
    }

    return objectValue ? (
        <div className="flex gap-1 items-center">
            Size: <div className="rounded-full p-1 border inline-flex text-center">
                <div className="w-full">
                    {objectValue}
                </div>
            </div>
        </div>
    ) : null
}

export default RoundSize;
